import type {App} from 'vue';
import type {AppAxiosRequestConfig} from '@/helpers/api';
import {order} from '@/api/order';

export default {
    install(app: App, options: AppAxiosRequestConfig) {

        order.defaults.baseURL = options.baseURL;

        if (options.params) {

            order.defaults.params = options.params;
        }

        app.provide("$order", order);
        app.config.globalProperties.$order = order;
    }
}